export class UserProject {
  RecordId?: number;
  Id?: number;
  UserId: number;
  ProjectId: number;
  CreatedBy: number;
  CreatedDate: string;
  ModifiedBy: number;
  ModifiedDate: string;
  IsActive: boolean;
  IsArchived: boolean;
  IsDeleted: boolean;

  constructor(obj?: Partial<UserProject>) {
    if (obj) {
      Object.assign(this, obj);
    } else {
      throw Error('Object cannot be null');
    }
  }

  isSoftDeleted(): boolean {
    return this.IsDeleted;
  }
}
